const translations = {
  "en": {
    "Account": "Account",
    "Add a brokerage, 401(k) or wallet and your holdings replace this preview.": "Add a brokerage, 401(k) or wallet and your holdings replace this preview.",
    "Connect a brokerage and I'll keep an eye on your investments.": "Connect a brokerage and I'll keep an eye on your investments.",
    "Connect Plaid": "Connect Plaid",
    "I'll keep an eye on your investments.": "I'll keep an eye on your investments.",
    "Link your first account": "Link your first account",
    "Link your invest account": "Link your invest account",
    "No investment accounts yet": "No investment accounts yet",
    "Send Ed a screenshot": "Send Ed a screenshot",
    "upload a screenshot": "Upload a screenshot",
    "Your accounts feed your dashboard": "Your accounts feed your dashboard",
    "Your accounts feed your dashboard →": "Your accounts feed your dashboard →"
  },
  "zh-tw": {
    "Account": "帳號",
    "Add a brokerage, 401(k) or wallet and your holdings replace this preview.": "新增券商、401(k) 或錢包，您的持倉將取代此預覽畫面。",
    "Connect a brokerage and I'll keep an eye on your investments.": "連結券商，我會為你持續追蹤你的投資。",
    "Connect Plaid": "連結 Plaid",
    "I'll keep an eye on your investments.": "我會持續追蹤您的投資。",
    "Link your first account": "連結你的第一個帳戶",
    "Link your invest account": "連結您的投資帳戶",
    "No investment accounts yet": "暫無投資帳戶",
    "Send Ed a screenshot": "傳送截圖給 Ed",
    "upload a screenshot": "上傳截圖",
    "Your accounts feed your dashboard": "您的帳戶資料將同步至儀表板。",
    "Your accounts feed your dashboard →": "您的帳戶已同步至儀表板 →"
  }
};

export default translations;
